module.exports = __webpack_public_path__ + "img/logo-ct.7c300e4d.png";